import type { SimulationMesh } from '@/simulation/mesh';

/**
 * Wavefront OBJ export of the current folded geometry.
 *
 * Vertex normals are emitted per triangle-corner so that the two sides of the
 * paper stay visually distinguishable in viewers that shade by normal.
 */
export function patternToObj(
  mesh: SimulationMesh,
  positions: Float32Array | Float64Array,
  name = 'model',
): string {
  const lines: string[] = [];
  lines.push('# Exported by fold.app');
  lines.push(`o ${name}`);
  for (let v = 0; v < mesh.vertexCount; v++) {
    lines.push(
      `v ${fmt(positions[v * 3])} ${fmt(positions[v * 3 + 1])} ${fmt(positions[v * 3 + 2])}`,
    );
  }
  for (let t = 0; t < mesh.triangleCount; t++) {
    const a = mesh.triangles[t * 3] + 1;
    const b = mesh.triangles[t * 3 + 1] + 1;
    const c = mesh.triangles[t * 3 + 2] + 1;
    lines.push(`f ${a} ${b} ${c}`);
  }
  return lines.join('\n') + '\n';
}

const fmt = (x: number): string => (Number.isFinite(x) ? x.toFixed(6) : '0.000000');
